import React, { useEffect, useState } from "react";
import { Outlet } from "react-router-dom";
import { func } from "prop-types";
// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";
import SideBar from "../SideBar/SideBar";
import brandTheme from "brandTheme/Theme";
import { apiHandler } from "assets/api";
import { endpoint } from "assets/api/endpoint";
import { Hidden } from "@material-ui/core";


const useStyles = makeStyles(({theme}) => ({
    container:{
        display:'flex',
        width:'100%',
        marginTop:'1%',
        height:'calc(100% - 140px)',
        overflowY:'auto',
    },
    content:{
        width:'100%',
           '@media only screen and (max-width: 600px)': {
         padding:"0px 10px",
         height:"calc(100vh - 117px)",
         overflow:'scroll'
    },
        '& .inputFieldContainer': {
          maxWidth: "1050px",
          margin: "0 auto",
        },
        '& .fieldContaienr':{
          margin: "2% 2% 0px 2%",
          maxWidth: "28%",
          "@media (max-width: 768px)": {
            maxWidth:'46%',
            margin: "5% 2% 0px 2%",
          },
          "@media (max-width: 600px)": {
            maxWidth:'100%',
          },
        },
    }
  }));


const InnerContent= ({handleDrawerToggle, mobileOpen, userDetailsData, featureFlagState})=> {
  const classes = useStyles();
  const [outletData, setOutletData]=useState(featureFlagState)
  return (
    <div  className={classes.container}>
             <Hidden smDown implementation="css">
      <div>
        
            <SideBar
              handleDrawerToggle={handleDrawerToggle}
              open={mobileOpen}
              outletData={outletData}
              userDetailsData={userDetailsData}
            />
          </div>
          </Hidden>
          <div className={classes.content}>
          <Outlet context={outletData} />
          </div>
    </div>
  );
}

InnerContent.propTypes = {
  handleDrawerToggle: func.isRequired,
};
export default InnerContent;
